<template>
  <div id="Status">
    <v-sheet class="mx-auto" max-width="700">
      <v-slide-group multiple show-arrows class="mt-4">
        <v-slide-item v-for="sticks in status" :key="sticks.name">
          <v-chip :color="getColor(sticks.name)" text-color="white" x-small class="mx-1">
            <span class="text-size">{{ sticks.name }} </span>
          </v-chip>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>
<script>
export default {
  name: 'Status',
  props: {
    status: {
      default: () => [],
      type: Array
    }
  },
  methods: {
    getColor(sticksName) {
      switch (sticksName) {
        case 'Pendente':
          return 'warning';
        case 'Entrega Direta':
          return 'primary';
        case 'Aceito Pelo Transbordo':
          return 'primary';
        case 'Alocado para Entregador':
          return 'primary';
        case 'Quarentena de Transferência':
          return 'warning';
        case 'Entregue Com Sucesso':
          return 'green';
        case 'Extraviado':
          return 'error';
        case 'A Devolver':
          return 'warning';
        case 'Devolvido Com Sucesso':
          return 'deep-purple darken-1';
        case 'Devolvido Com Pendência':
          return 'error';
        case 'Devolvido para Reentrega':
          return 'error';
        case 'Em transferência':
          return 'primary';
        case 'Quarentena de Entrega':
          return 'warning';
        case 'Tentar entregar novamente':
          return 'warning';
        case 'Devolvido Pelo Transbordo':
          return 'warning';
        default:
          return 'primary';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.text-size {
  font-size: x-small;
}
.v-slide-group {
  .v-slide-group__next,
  .v-slide-group__prev {
    align-items: center;
    display: flex;
    flex: 0 1 52px;
    justify-content: center;
    min-width: 0px;
  }
}
</style>
